import { tableCellClasses } from '@mui/material/TableCell';
import { tablePaginationClasses } from '@mui/material/TablePagination';

const tableContainerStyle = {
  background: 'white',
  width: '95%',
  margin: 'auto',
  borderBottom: 'none',
  alignItems: 'flex-end',
};

const tableStyle = {
  minWidth: 650,
  borderCollapse: 'separate',
  borderSpacing: '0px 5px',
  background: '#f6f7fc !important',
  height: '20vh',
  overflow: 'auto',
  [`& .${tableCellClasses.root}`]: {
    borderBottom: 'none',
    fontFamily: 'metropolis',
  },
};

const tableHead = {
  background: '#f6f7fc',
};

const tableRowStyle = {
  '&:last-child td, &:last-child th': { border: 0 },
  background: 'white',
  alignItems: 'center',
};
const subtableRowStyle = {
  '&:last-child td, &:last-child th': { border: 0 },
  [`& .${tableCellClasses.root}`]: {
    marginTop: 0,
  },
  background: 'white',
};

const tableCellStyle = {
  fontWeight: 'bold',
};

const tablePaginationStyle = {
  [`& .${tablePaginationClasses.selectLabel}`]: {
    fontFamily: 'metropolis',
  },
  [`& .${tablePaginationClasses.displayedRows}`]: {
    fontFamily: 'metropolis',
  },
  [`& .${tablePaginationClasses.select}`]: {
    fontFamily: 'metropolis',
  },
};
export default {
  tableContainerStyle,
  tableStyle,
  tableHead,
  tableRowStyle,
  tableCellStyle,
  subtableRowStyle,
  tablePaginationStyle,
};
